export default {
  beforeMount: function (el) {
    el.addEventListener('click', function () {
      this.setSelectionRange(0, this.value.length);
    });
  },
};
